const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/SynedraIFrameViewerPage/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        title: 'Bilddiagnostik',
    },
    __RELATIVE_SOURCE_FILE__
);
